import Choices from 'choices.js';

export const choicesJS = () => {
    // Initialize all select elements with the class 'choices-select'
    const selectElements = document.querySelectorAll('.portfolio--block select');

    selectElements.forEach(select => {
        new Choices(select, {
            searchEnabled: false,
            itemSelectText: '',
            shouldSort: false,
            position: 'bottom'
        });
    });
}; 